<template>
  <div :key="card.id" v-for="card in cards" class="">
  <div class="relative overflow-hidden rounded-lg shadow border-2 border-yellow hover:shadow-md dark:shadow-gray-800">
    <div class="">
      <img :src="card.img" class="cover group-hover:scale-105 duration-500 ease-in-out rounded-t-lg _h-32 w-1/1"
        alt="">
      <div class="absolute top-0 left-0 pt-3 pl-3">
        <a href=""  class="bg-bsd-700 text-white text-xs font-semibold px-2.5 py-0.5 rounded w-fit mx-auto h-5"> {{card.model}} </a>
      </div>
    </div>

    <div
      class="group p-6 md:px-4 border-t-yellow text-center transition-all duration-500 ease-in-out">
      <div class="content mt-4">
        <a href="page-services.html" class="title h5 text-lg font-medium _text-yellow hover:text-bsd-700">{{ card.name }}</a>
        <p class="text-justify _text-slate-400 mt-3">{{ card.desc }}</p>

        <div class="mt-5">
          <i class="uil uil-arrow-right text-bsd-700 font-bold text-xl"></i>
          <router-link :to="card.link"  class="btn btn-link text-bsd-700 hover:text-bsd-700 after:bg-indigo-600 duration-500 ease-in-out">{{ card.buttonName }}</router-link>
          
        </div >
     
      </div>
  

    </div>
  </div>
</div>
<div class="fixed top-6 right-12 z-50 w-64 h-24  overflow-hidden   ">
  
  <picture>
  <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f61c/512.webp" type="image/webp">
  <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f61c/512.gif" alt="😜" width="32" height="32">
</picture>
</div>
<div class="fixed top-12 right-16 z-50 w-64 h-24  overflow-hidden   ">
  
  <picture>
  <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f61c/512.webp" type="image/webp">
  <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f61c/512.gif" alt="😜" width="32" height="32">
</picture>
</div>

</template>

<script>
export default {
  data() {
    return {
      cards : {
        product1 :{
          model:"BSD-QR100",
          name: 'QR SURVEY',
          desc: "Pour savoir ce que pense les  clients de vos produits ou services,QR SURVEY  fournit des codes qr qu'ils peuvent scanner pour laisser leur avis ou formuler des plaintes.",
          link: '/qrLink',
          buttonName: 'Voir plus de détails',
          img: require('../assets/images/bsdKit/Porte-menu-plexi-courbe-QR-code.webp')
        },
        product2: {
          model:"BSD-ELECTRO100",

          name: 'ELECTRO SURVEY',
          desc: "il s'agit d'un kit electronique intuitive ,tres simple et pratique qui permet aux client de laisser leur avis juste par un clique sur l'un des trois emoticones.",
          link: '/comptoir',
          buttonName: 'Voir plus de détails',
          img: require('../assets/images/bsdKit/Porte-menu-bsd.webp')
        },
        product3: {
          model:"BSD-TOUCH100",

          name: 'TOUCH SURVEY',
          desc: 'Grace á  son écran tactile,et sa sortie audio, les clients peuvent laisser leur avis sur vos produits ou services juste en un click ou formuler des plaintes. ',
          link: '/standTouch',
          buttonName: 'Voir plus de détails',
          img: require('../assets/images/bsdKit/Porte-menu-tablet.webp')
        },
      }
    }
  }
}
</script>

